

import React from 'react';
import {Container, NavDropdown, Nav, Navbar, Form, FormControl,Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../stylesheets/navbar.css"
import "../js/main.js"


const BookOptions = () => {
  
        
return(

    <div class="row">
    <div class="col-md-12 bookmenuoptions" >
    <div class="row">

    <div class="col-md-2" >
    <Form.Select size="lg" style={{marginTop:"10px"}} className="bookmenuselectoptions">
    <option>Select Apartment</option>
    <option value="New York">New York</option>
    <option value="Istanbul">Select Apartment</option>
  </Form.Select>
    </div>

    <div class="col-md-2 addborderleft">
    <Form.Select size="lg" style={{marginTop:"10px"}} className="bookmenuselectoptions">
    <option>Select No of Rooms</option>
    <option value="1">1</option>
    <option value="1">2</option>
  </Form.Select>
    </div>

    <div class="col-md-2 addborderleft">
    <Form.Select size="lg" style={{marginTop:"10px"}} className="bookmenuselectoptions">
    <option>Check In</option>
  </Form.Select>
    </div>

    <div class="col-md-2 addborderleft">
    <Form.Select size="lg" style={{marginTop:"10px"}} className="bookmenuselectoptions">
    <option>Check Out</option>
  </Form.Select>
    </div>

    <div class="col-md-2 addborderleft">
    <Form.Select size="lg" style={{marginTop:"10px"}} className="bookmenuselectoptions">
    <option>Check Out</option>
  </Form.Select>
    </div>

    <div class="col-md-2">
   <p className="bookmenuoptionsbuttonp"><button style={{marginTop:"10px"}} className="bookmenuoptionsbutton">Book</button></p> 
    {/* <button class="signinbutton">Search</button> */}
    </div>
    </div>
    </div>
</div>


)

};


export default BookOptions;